import { useCallback, useMemo, useState } from "react";

import { validateTopicsCreationLength } from "app/pages/activation/helpers/topics/validateTopicsCreationLength";

type UseTopicSelectionSchema = {
    createdTopicsLength: number;
    track: {
        trackRemoveTopicFromCreation: (keyword: string, isSuggestion: boolean) => void;
        trackSelectTopic: (keyword: string, isSuggestion: boolean) => void;
    };
};

export const useTopicSelection = ({ createdTopicsLength, track }: UseTopicSelectionSchema) => {
    const [selectedTopics, setSelectedTopics] = useState<string[]>([]);
    const { message, isMaxSelected, isMaxForOneAddSelected } = useMemo(
        () => validateTopicsCreationLength(createdTopicsLength, selectedTopics.length),
        [createdTopicsLength, selectedTopics.length],
    );

    const selectTopic = useCallback(
        (keyword: string, isSuggestion: boolean) => () => {
            setSelectedTopics((prev) => {
                const isSelected = prev.includes(keyword);
                const { isValid } = validateTopicsCreationLength(createdTopicsLength, prev.length);
                if (isSelected) {
                    track.trackRemoveTopicFromCreation(keyword, isSuggestion);
                    return prev.filter((k) => k !== keyword);
                } else {
                    track.trackSelectTopic(keyword, isSuggestion);
                    return isValid ? [...prev, keyword] : prev;
                }
            });
        },
        [createdTopicsLength, track],
    );
    return {
        selectedTopics,
        message,
        isMaxSelected,
        isMaxForOneAddSelected,
        setSelectedTopics,
        selectTopic,
    };
};
